module.exports = __webpack_public_path__ + "img/index5.82c4e6a8.png";